import { ColumnDef } from '@tanstack/react-table';
import { format, parseISO } from 'date-fns';
import { ActingQueryData } from '@area-restrita/api-client/model/actingQueryData';

import ChecklistCell from './ChecklistCell';
import AbortActingAction from '../../components/AbortActingAction';

export const columns: ColumnDef<ActingQueryData>[] = [
  {
    header: 'Iniciado Por',
    accessorFn: (row) => row.startedBy.name ?? 'N/A',
  },
  {
    header: 'Status',
    accessorFn: (row) => row.status.toUpperCase(),
  },
  {
    header: 'Iniciado Em',
    accessorFn: (row) => format(parseISO(row.startedAt), 'dd/MM/yyyy HH:mm'),
  },
  {
    header: 'Finalizado Em',
    accessorFn: (row) =>
      row.finishedAt
        ? format(parseISO(row.finishedAt), 'dd/MM/yyyy HH:mm')
        : '-',
  },
  {
    header: 'Rota',
    accessorFn: (row) => row.busline.code,
  },
  {
    header: 'Total de passageiros',
    accessorKey: 'lastPassengerCount',
    cell: ({ row }) => row.original.lastPassengerCount ?? '-',
  },
  {
    header: 'Checklist',
    accessorFn: (row) => row.usedChecklist?.name ?? 'N/A',
    cell: ChecklistCell,
  },
  {
    header: 'Ações',
    meta: { className: 'text-right' },
    cell: function ActingActionsCell({ row }) {
      return (
        <div className="flex justify-end">
          <AbortActingAction acting={row.original} />
        </div>
      );
    },
  },
];
